import { Input } from "antd";
import React from "react";
import { ActionLinkComponent2 } from "./ActionLinkComponent";
import styled from "styled-components";

const InputWraper = styled(Input)`
  height: 50px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  & .ant-input-suffix > div {
    display: flex;
    align-items: center;
    padding-left: 20px;
    height: 26px;
    border-left: 1px solid rgba(0, 0, 0, 0.15);
    @media (max-width: 1024px) {
      padding-left: 10px;
    }
  }
  & input {
    text-overflow: ellipsis;
    color: #F12E11;
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

const Label = styled.span`
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: inline-block;
  min-width: 176px;
  @media screen and (min-width: 1025px) {
    max-width: 176px;
  }
`;

export const LinkItem = ({ value, title }) => {
  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2.5 lg:gap-8">
      <Label>{title}</Label>
      <InputWraper
      
        value={value}
        suffix={<ActionLinkComponent2 value={value} />}
      />
    </div>
  );
};
